import { Stack } from '@mui/material'

export default function Footer(props: { children: React.ReactNode }) {
  return (
    <Stack direction="row" spacing={2} justifyContent="flex-end" pt={4}>
      {props.children}
    </Stack>
  )
}
